import { BaseView } from './BaseView';
import { registerSchema } from './transform';

export class EventBasic {
  Id: number = 0;
  Code: string = '';
  Name: string = '';
  IconUrl: string = '';
  PhotoUrl: string = '';
  StartDate: Date = new Date();
  EndDate: Date | null = null;
  TimesShown: boolean = true;
  TimeZoneIdentifier: string = '';
  Address: string = '';
  PlaceName: string | null = null;
  CountryCode: string = '';
  AttendeesCount: number = 0;
  IsAttending: boolean = false;
  IsFollowing: boolean = false;
  DistanceKm: number | null = null;

  get PlaceNameShort(): string {
    if (!this.PlaceName) {
      return '';
    }
    const parts = this.PlaceName.split(',');
    return parts[0]?.trim() ?? '';
  }

  get PlaceNameCleaned(): string {
    if (!this.PlaceName) {
      return '';
    }

    const parts = this.PlaceName.trim()
      .split(',')
      .map(part => part.trim())
      .filter(part => part.length > 0);

    return parts.join(', ');
  }
}

export class EventsView extends BaseView {
  EventsItems: EventBasic[] = [];
  CanCreateEvents?: boolean;
}

export class DiscoverEventsView {
  HasLocation: boolean = false;
  UpcomingEvents: EventBasic[] = [];
  NearbyEvents: EventBasic[] = [];
  NetworkEvents: EventBasic[] = [];
  PastEvents: EventBasic[] = [];
}

registerSchema(EventBasic, {
  StartDate: 'date',
  EndDate: 'date',
});

registerSchema(EventsView, {
  EventsItems: [EventBasic],
});

registerSchema(DiscoverEventsView, {
  UpcomingEvents: [EventBasic],
  NearbyEvents: [EventBasic],
  NetworkEvents: [EventBasic],
  PastEvents: [EventBasic],
});
